// A row of small progress dots for a multi-step flow, e.g. a creation
// wizard's own footer. The one real multi-step flow anywhere in the
// prototype (a space-creation wizard: Name -> Purpose -> People ->
// Knowledge) is otherwise just a Modal with per-step content and
// Back/Next buttons, both already covered by this library's own Modal
// and Button, so only the dots themselves are a new, genuinely reusable
// piece; the rest stays the consumer's own composition.

export interface StepperProps {
  /** Total number of steps. */
  steps: number;
  /** The current step, 0-indexed. */
  currentStep: number;
  /** Accessible name for the progress bar, e.g. "Question 2 of 5". */
  label?: string;
}

function dotClassName(index: number, currentStep: number): string {
  return [
    "size-1.5 rounded-full",
    index === currentStep ? "bg-brand-primary" : index < currentStep ? "bg-content-tertiary" : "bg-border-input",
  ].join(" ");
}

export function Stepper({ steps, currentStep, label }: Readonly<StepperProps>) {
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuenow={currentStep + 1}
      aria-valuemin={1}
      aria-valuemax={steps}
      className="flex items-center gap-1.5"
    >
      {Array.from({ length: steps }, (_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: a static-length, never-reordered list; position is the only real identity a plain step dot has.
        <span key={i} className={dotClassName(i, currentStep)} />
      ))}
    </div>
  );
}
